<footer class="qc-footer">
    <cv-version-label></cv-version-label>
    <span class="cv-btn-label cv-rights">
		<span *ngIf="uiConfigStyle?.legend; else defaultLegend">
			{{uiConfigStyle?.legend}}
		</span>
		<ng-template #defaultLegend>
			© {{ today | date:'yyyy'}} Class Valuation LLC – All Rights Reserved.
		</ng-template>
    </span>
</footer>

